import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import * as _ from 'lodash';

export type TOPTION_LIST_ITEM = {
  key: string;
  displayName: string;
};

export type TOPTION_STATUS_ITEM = {
  type: string;
  color: string;
};

export type TSingleSelectMobileModalDismissEmitVal =
  | {
      role?: 'ON_CLEAR' | 'ON_SELECTED';
      data: undefined;
    }
  | {
      role: 'ON_SELECTED';
      data: string;
    };

@Component({
  selector: 'monorepo-single-select-mobile',
  templateUrl: './single-select-mobile.component.html',
  styleUrls: ['./single-select-mobile.component.scss'],
})
export class SingleSelectMobileComponent implements OnInit {
  @Input() optionList: TOPTION_LIST_ITEM[] = [];
  @Input() statusConf?: TOPTION_STATUS_ITEM[];
  @Input() selectedItem: string | undefined = undefined;
  @Input() title = '';
  @Input() isDisabled = false;
  @Input() hasClear = true;
  @Input() showOptionKey = true;

  currentSelected: string | undefined = undefined;
  searchTerm: string = '';
  @Input() filteredOptionList: TOPTION_LIST_ITEM[] = [];
  @Input() filteredStatusConf: TOPTION_STATUS_ITEM[] = [];
  @Input() uniqueStatusConf: TOPTION_STATUS_ITEM[] = [];

  constructor(private modalCtrl: ModalController) {}

  ngOnInit() {
    this.currentSelected = this.selectedItem;
    this.filteredOptionList = this.optionList;
    if (this.statusConf) {
      this.filteredStatusConf = this.statusConf;
      this.uniqueStatusConf = _.uniqBy(this.statusConf, 'type');
    }
  }

  filterOptions() {
    const filteredOptions = this.optionList.filter((option) =>
      option.displayName.toLowerCase().includes(this.searchTerm.toLowerCase()),
    );
    this.filteredOptionList = filteredOptions;

    if (this.statusConf) {
      const filteredStatuses = this.statusConf.filter((status, i) =>
        this.filteredOptionList.includes(this.optionList[i]),
      );
      this.filteredStatusConf = filteredStatuses;
    }
  }

  changeSelected(selectedOption: TOPTION_LIST_ITEM) {
    this.currentSelected = selectedOption.key;
  }

  clearFilter() {
    this.modalCtrl.dismiss(undefined, 'ON_CLEAR');
  }

  applyFilter() {
    this.emitSelectedFilter(this.currentSelected);
  }

  emitSelectedFilter(selected: string | undefined) {
    this.modalCtrl.dismiss(selected, 'ON_SELECTED');
  }

  dismissModal() {
    this.modalCtrl.dismiss();
  }
}
